import React from 'react';
import { TooltipText } from '@components/TooltipText';
import { ColumnProps } from 'primereact/column';
import { DATE_FNS_FORMAT, timestampToFormattedDate } from '@utilities/date';

export const COLUMNS: ColumnProps[] = [
	{ field: 'leadName', header: 'Lead Name' },
	{ field: 'projectName', header: 'Project Name' },
	{ field: 'projectId', header: 'Project Id' },
	{ field: 'activityName', header: 'Activity Name' },
	{
		field: 'subActivityName',
		header: 'Sub Activity Name'
	},
	{
		field: 'expectedEndDate',
		header: 'Expected End Date',
		body: (approval: Record<string, any>) => <span>{timestampToFormattedDate(approval.expectedEndDate, DATE_FNS_FORMAT)}</span>
	},
	{
		field: 'requestedEndDate',
		header: 'Requested End Date',
		body: (approval: Record<string, any>) => <span>{timestampToFormattedDate(approval.requestedEndDate, DATE_FNS_FORMAT)}</span>
	},
	{
		field: 'approvalStatus',
		header: 'Approval Status',
		body: (approval: Record<string, any>) => {
			const status = APPROVAL_STATUSES[approval.approvalStatus];
			return (
				<span className={`px-2 py-1 text-skin-inverted rounded-lg text-sm font-semibold ${status.colorClass}`}>
					{status.label}
				</span>
			);
		}
	},

	{
		field: 'reason',
		header: 'Reason',
		body: (approval: Record<string, any>) => {
			return <TooltipText id={approval.reason} tooltipText={approval.reason} charCount={30} />;
		}
	}
];

export const SORT_COLUMN_KEYS = {
	addedOn: 'ADDED_ON',
	updatedOn: 'UPDATED_ON'
};

export enum APPROVAL_STATUS_KEYS {
	PENDING = 'PENDING',
	AUTO_APPROVED = 'AUTO_APPROVED',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED'
}

export const APPROVAL_STATUSES: any = {
	[APPROVAL_STATUS_KEYS.PENDING]: {
		key: APPROVAL_STATUS_KEYS.PENDING,
		label: 'Pending',
		colorClass: 'bg-[var(--color-accent)]'
	},
	[APPROVAL_STATUS_KEYS.AUTO_APPROVED]: {
		key: APPROVAL_STATUS_KEYS.AUTO_APPROVED,
		label: 'Auto Approved',
		colorClass: 'bg-[var(--color-success)]'
	},
	[APPROVAL_STATUS_KEYS.APPROVED]: {
		key: APPROVAL_STATUS_KEYS.APPROVED,
		label: 'Approved',
		colorClass: 'bg-[var(--color-success)]'
	},
	[APPROVAL_STATUS_KEYS.REJECTED]: {
		key: APPROVAL_STATUS_KEYS.REJECTED,
		label: 'Rejected',
		colorClass: 'bg-[var(--color-danger)]'
	}
};
